import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {MessageModel} from '../../../models/api/messageModel';
import {PrecogModel, PrecogTypesEnum} from '../../../models/api/precogModel';
import {deletePrecog} from '../../../services/precogs';
import {ThunkAction} from '../../appThunk';
import {ResourceMap} from '../../appTypes';

/*
 * Actions types.
 */

export enum MessageActionsEnum {
  MESSAGE_DELETED = '@@data/messages/MESSAGE_DELETED',
}

/*
 * Types.
 */

interface MessageDeletedPayload {
  messageUid: string;
  deletedAt: number;
}

export interface MessageDeletedAction extends ActionWithPayload<MessageDeletedPayload> {
  type: MessageActionsEnum.MESSAGE_DELETED;
}

/*
 * Delete.
 */

export function deleteMessageAction(messageUid: string, deletedAt: number): ThunkAction {
  return (dispatch, getState) => {
    // Find the existing message.
    const {messages, conversationPrecogs} = getState().data;
    const existingMessage = messages[messageUid];

    // If none was found, nothing to do.
    if (!existingMessage) {
      return null;
    }

    // If needed, remove the precog for this draft.
    const authorPrecog = findDraftPrecog(conversationPrecogs, existingMessage);
    if (authorPrecog) {
      dispatch(deletePrecog(authorPrecog));
    }

    // Dispatch the delete action.
    const action: MessageDeletedAction = {
      type: MessageActionsEnum.MESSAGE_DELETED,
      payload: {messageUid, deletedAt},
    };
    return dispatch(action);
  };
}

export function findDraftPrecog(
  precogs: ResourceMap<ReadonlyArray<PrecogModel>>,
  draftMessage: MessageModel,
) {
  const conversationPrecogs = draftMessage.conversationId && precogs[draftMessage.conversationId];
  const authorPrecog =
    conversationPrecogs && draftMessage.authorId && conversationPrecogs[draftMessage.authorId];
  if (!authorPrecog) {
    return undefined;
  }

  // Check its type.
  if (authorPrecog.type !== PrecogTypesEnum.MESSAGE) {
    return undefined;
  }

  // Check the conversation.
  if (authorPrecog.conversationId !== draftMessage.conversationId) {
    return undefined;
  }

  return authorPrecog;
}

/*
 * Union type.
 */

export type MessagesAction = MessageDeletedAction;
